"use client";

import { useSticky } from "@/lib/hooks/use-sticky";
import { cn } from "@jace/ui";
import Link from "next/link";
import { CtaButton } from "./cta-button";
import { HeaderButtons } from "./header-buttons";
import { JaceLogo } from "./jace-logo";
import { MobileMenu } from "./mobile-menu";

const navigation = [
	{ name: "Features", href: "/" },
	{ name: "Company", href: "/about" },
	{ name: "Pricing", href: "/#pricing" },
	{ name: "Blog", href: "/blog" },
	// { name: "Affiliate", href: "/affiliate" },
];

export function Header() {
	const { ref, isSticky } = useSticky({ offsetTop: 50 });

	return (
		<>
			<div id="marker" className="h-[10px] absolute top-0" ref={ref} />
			<header className="inset-x-0 top-0 z-20 sticky">
				<nav
					aria-label="Global"
					className={cn(
						"mx-auto flex max-w-7xl items-center justify-between transition-all p-2",
						isSticky ? "p-4" : "",
					)}
				>
					<div
						className={cn(
							"flex items-center justify-between w-full p-4 transition-all bg-page-bg/50",
							isSticky
								? "backdrop-blur-2xl rounded-2xl overflow-hidden shadow-lg"
								: "",
						)}
					>
						<div className="flex lg:flex-1">
							<Link href="/" className="-m-1.5 p-1.5">
								<span className="sr-only">Jace AI</span>
								<JaceLogo className="fill-white w-[50px] sm:w-[70px]" />
							</Link>
						</div>

						<div className="flex justify-center gap-5">
							<CtaButton
								className="md:hidden"
								placement="header"
								size="default"
							/>
							<MobileMenu navigation={navigation} />
						</div>

						<div className="hidden lg:flex lg:gap-x-12">
							{navigation.map((item) => (
								<Link
									key={item.name}
									href={item.href}
									className="text-md/6 font-semibold text-white hover:text-opacity-80 hover:underline decoration-highlight-yellow underline-offset-4 transition-all"
								>
									{item.name}
								</Link>
							))}
						</div>

						<div className="hidden lg:flex lg:flex-1 lg:justify-end lg:gap-x-6">
							<HeaderButtons placement="header" />
						</div>
					</div>
				</nav>
			</header>
		</>
	);
}
